// src/app/components/antenna/animated-number.tsx
//
// Isolated count-up display. Owns the tween via useCountUp so only this node
// re-renders during the animation. Non-numeric input (e.g. a no-data dash) renders
// the raw value with no animation.
import { useCountUp } from "@/app/hooks/use-count-up";

interface AnimatedNumberProps {
  value: number | string;
  format?: (n: number) => string;
}

export function AnimatedNumber({ value, format }: AnimatedNumberProps) {
  const isNumeric = typeof value === "number" && Number.isFinite(value);
  const animated = useCountUp(isNumeric ? (value as number) : 0);

  if (!isNumeric) return <>{value}</>;

  const text = format ? format(animated) : String(Math.round(animated));
  return <span style={{ fontVariantNumeric: "tabular-nums" }}>{text}</span>;
}
